import { rem } from 'polished'
import styled, { css } from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import theme from 'styles/theme'
import { Title26, Title60 } from 'components/Typography'
import { Container as BaseContainer } from 'styles/sharedStyle'

const mobileMaxHeight = '230px'
const mobileMaxWidth = '380px'

export const Content = styled.div`
  display: flex;
  justify-content: center;
  padding: ${rem(36)} 0px;
  position: relative;

  ${({ background, theme: propsTheme }) =>
    background === 'White'
      ? css`
          margin-top: -1px;
          border-top: 1px solid ${propsTheme.colors.sagemediumToGreen};
        `
      : css`
          width: 100%;
          max-width: 100%;
          background: ${propsTheme.colors.mushroomGrey};
          z-index: 2;
          margin-top: initial;
        `}

  ${(props) => props.theme.mediaQueries.medium} {
    padding: ${rem(62)} 0px;
  }
`

export const Container = styled(BaseContainer)`
  width: 100%;
  max-width: 100%;
  padding: initial;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  width: ${mobileMaxWidth};

  ${theme.mediaQueries.medium} {
    max-height: 325px;
    max-width: 980px;
    text-align: inherit;
    width: 100%;
    flex-direction: ${(props) => (props?.invert ? 'row-reverse' : 'row')};
  }

  ${({ variant }) =>
    variant === 'memDays' &&
    `
    ${theme.mediaQueries.smallOnly} {
      max-width: 300px;
    }
  `}
`

export const SuperTitle = styled(Title60)`
  font-size: ${rem(42)};
  margin: 0 auto ${rem(30)};
  padding: ${rem(26)} 0px;
  max-width: 8.34em;
  text-align: center;

  ${theme.mediaQueries.medium} {
    font-size: ${rem(60)};
    padding: ${rem(53)} 0px;
  }
`

export const Image = styled(GatsbyImage)`
  height: 100%;
  width: 100%;
  max-height: ${mobileMaxHeight};
  max-width: ${mobileMaxWidth};

  ${theme.mediaQueries.medium} {
    flex: 0 0 auto;
    max-height: 325px;
    max-width: 415px;
  }
`

export const Picture = styled.picture`
  background-color: rgb(49, 49, 49);
  display: block;
  height: 100%;
  max-height: ${mobileMaxHeight};
  max-width: ${mobileMaxWidth};
  width: 100%;

  ${theme.mediaQueries.medium} {
    flex: 0 0 auto;
    max-height: 325px;
    max-width: 415px;
  }

  img {
    display: block;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
    opacity: 0.65;
    width: 100%;
  }
`

export const InfoWrapper = styled.div`
  background-color: transparent;
  color: ${({ theme: propsTheme }) => propsTheme.colors.sagedarkToSandstone};
  padding: ${theme.space[6]};

  ${(props) => props.theme.mediaQueries.medium} {
    padding: 67px ${theme.space[11]};
    width: 100%;
    color: ${({ theme: propsTheme }) => propsTheme.colors.black};
  }
`

export const Headline = styled(Title26)`
  margin-bottom: ${theme.space[4]};
  font-family: ${(props) => props.theme.textStyles.aimeRegularFont};
  font-width: 400;
`

export const InfoHeader = styled.div`
  background: rgba(27, 27, 27, 0.35);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  left: 0;
  max-height: ${mobileMaxHeight};
  min-height: ${mobileMaxHeight};
  position: absolute;
  right: 0;
  top: 0;
  color: ${(props) => props.theme.colors.sagedarkToSandstone};

  ${theme.mediaQueries.medium} {
    background: none;
    display: inherit;
    height: auto;
    max-height: none;
    min-height: auto;
    padding-top: 0;
    position: static;
    color: ${(props) => props.theme.colors.black};
  }

  ${({ variant }) =>
    variant === 'memDays' &&
    `
    background: none;
  `}
`

export const InfoButton = styled.div`
  padding-top: ${theme.space[2]};

  ${theme.mediaQueries.medium} {
    padding-top: ${theme.space[2]};
  }
`

export const BodyCopy = styled.div`
  color: ${(props) => props.theme.colors.sagemedium};
  text-align: center;

  p {
    font-size: 14px;
    line-height: 20px;
  }

  h6 {
    ${theme.textStyles.body10Uppercase}
    font-size: ${rem(10)};
    margin: 0 0 ${rem(20)};
  }

  ul, ol, dl {
    text-align: initial;
  }

  ${theme.mediaQueries.medium} {
    text-align: inherit;
    max-height: 110px;
    overflow: auto;
  }
`
